import { geoPatterson as patterson , geoChamberlin as chamberlin } from 'd3-geo-projection'
import * as geo from 'd3-geo'

const PROJECTIONS = {
  globe: geo.geoOrthographic,
  usa: geo.geoAlbersUsa,
  chamberlin,
  map: patterson
}

const FEATURES = {
  ALASKA: 5879092,
  HAWAII: 5855797,
  MICHIGAN: 5001836,
  EUROPE: 6255148,
  NORTH_AMERICA: 6255149,
  RUSSIA: 2017370,
  USA: 6252001,
  WORLD: 6295630
}

export { PROJECTIONS, FEATURES }

export function get (node, geojson, {width, height}) {
  let type = 'map' // default to the basic map projection

  const overrides = {}

  overrides[FEATURES.USA] = 'usa'
  overrides[FEATURES.NORTH_AMERICA] = 'chamberlin'

  if (overrides[node.key]) {
    type = overrides[node.key]
  }

  let settings = PROJECTION_SETTINGS[node.key]
    , Projection = PROJECTIONS[type]
    , args = settings?.constructor_args || []
    , projection = new Projection(...args)

  // By default the projection is fit to the geojson
  projection.fitSize([width, height], geojson)

  settings?.adjust?.(projection, geojson, {width, height})

  return projection
}

/*
 * Some projections need to be set explicitly for the geojson used and we
 * can't rely on fitSize. e.g. Russia
 */
const PROJECTION_SETTINGS = {}

PROJECTION_SETTINGS[FEATURES.NORTH_AMERICA] = {
  constructor_args: [[-155, 55], [-35, 55], [-92.5, 10]], // The 3 coordinates used for the chamberlin projection. Stolen from https://observablehq.com/@toja/chamberlins-trimetric-projection-of-north-america
  adjust: (projection, geojson, {width, height}) => {
    projection.center([0, 0]) // Reset the projections center/translate. Needed for propert transitions from NA -> Country
              .translate([0, 0])
              .fitSize([width, height], geojson)
  }
}

PROJECTION_SETTINGS[FEATURES.RUSSIA] = {
  adjust: (projection, geojson, {width, height}) => {
    projection.rotate([-11, 0]) // Rotate `x` to help align these features
              .fitSize([width, height], geojson)
  }
}

PROJECTION_SETTINGS[FEATURES.EUROPE] = {
  adjust: (projection, geojson, {width, height}) => {
    projection.rotate([-11, 0]) // Rotate `x` to help align these features
              .fitSize([width, height], geojson)
  }
}
